import { BREAKPOINTS } from './breakpoints';
import { COLORS } from './colors';
import { SPACING } from './spacing';
import { RADIUS } from './radius';
import { ELEVATIONS } from './elevations';
import { TRANSITIONS } from './transitions';
import { Z_INDEX } from './zIndex';

export const theme = {
  colors: COLORS,
  breakpoints: BREAKPOINTS,
  spacing: SPACING,
  radius: RADIUS,
  elevations: ELEVATIONS,
  transitions: TRANSITIONS,
  zIndex: Z_INDEX,
};
